import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-only-in-stock',
  templateUrl: './template.html',
  styleUrls: ['./styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OnlyInStockComponent implements OnInit, OnChanges {
  checkbox = new FormControl()

  @Input() enabled: boolean
  @Output() toggled = new EventEmitter<void>()

  ngOnInit() {
    this.checkbox.valueChanges
      .subscribe(this.emitToggle.bind(this))
  }

  ngOnChanges(changes: SimpleChanges) {
    this.checkbox.setValue(changes.enabled.currentValue, { 
      emitEvent: false
    })
  }

  emitToggle() {
    this.toggled.emit()
  }
}
